import React from 'react'
import PropTypes from 'prop-types'

import {
  ProcessCardContanier,
  CardTitle,
  ProcessCardWrapper,
  ProcessLine,
  CardWrapper,
  ProcessIcon,
  ProcessText,
} from './style'

const ProcedureCard = ({ title, content }) => {
  return (
    <ProcessCardContanier>
      <CardTitle>{title}</CardTitle>
      <ProcessCardWrapper>
        <ProcessLine></ProcessLine>
        {content.map((item, index) => (
          <CardWrapper key={index}>
            <ProcessIcon src={item.icon} alt=""></ProcessIcon>
            <ProcessText>{item.text}</ProcessText>
          </CardWrapper>
        ))}
      </ProcessCardWrapper>
    </ProcessCardContanier>
  )
}

ProcedureCard.propTypes = {
  title: PropTypes.string,
  content: PropTypes.array,
}

export default ProcedureCard
